import { isProviderApp, isAdminApp } from "../../config/theme";
import { usePageTracking } from "../../analytics";
import HomeownerAppRouter from "./homeowner";
import ProviderAppRouter from "./provider";
import AdminAppRouter from "./admin";

export default function AppRouter() {
  usePageTracking();

  // Detect subdomain and route to appropriate app
  if (isAdminApp()) {
    return <AdminAppRouter />;
  }
  return isProviderApp() ? <ProviderAppRouter /> : <HomeownerAppRouter />;
}
